module.exports = __webpack_public_path__ + "static/media/intlopen-logo-glow.b7365280.png";